module.exports = __webpack_public_path__ + "static/media/nav-logo.1cc0784a.svg";